import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

// Keep each form mounted while giving its submit button a visible, accessible sending state.
export default function SubmissionButtonContent({ submitting, children }) {
    return (
        <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: '6px', maxWidth: '100%', whiteSpace: 'nowrap', letterSpacing: 0 }} role={submitting ? 'status' : undefined}>
            {/* Modal.css sets every spinner to 70px; keep button indicators independent of that legacy rule. */}
            {submitting && <Spinner animation="border" size="sm" aria-hidden="true"
                style={{ width: '14px', height: '14px', borderWidth: '2px', flex: '0 0 14px' }} />}
            <span>{submitting ? 'Odesílám...' : children}</span>
        </span>
    );
}
